import { Stack } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";

import StacksTableVendorCellContent from "./Content";

const StacksTableVendorCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <StacksTableVendorCellContent stack={stack} />
    </TableSimpleCell>
  );
};

export default StacksTableVendorCell;
